import cx from 'classnames';
import { Features } from 'mk2/apps/strollers/schemas';
import { niceNumber } from 'mk2/apps/strollers/utils';
import { hasVal } from 'mk2/helpers/sanitize';
import React from 'react';
import styles from './MinMaxDimensionsFeature.mscss';

interface OwnProps {
    className?: string;
    features: Features;
    feature: any;
}

const renderRange = (minValue, maxValue) => {
    if (hasVal(minValue) && hasVal(maxValue) && minValue !== maxValue) {
        return `${niceNumber(minValue)}–${niceNumber(maxValue)}`;   // beware: ndash used
    }
    const value = maxValue || minValue;
    return hasVal(value) ? niceNumber(value) : '?';
};

export class MinMaxDimensionsFeature extends React.Component<OwnProps> {
    public render() {
        const { feature, features, className } = this.props;

        if (!feature.hasWorthyValue(features)) {
            return null;
        }

        const dims = feature.getDims(features);

        return (
            <div className={cx(styles.MinMaxDimensionsFeature, className)}>
                {renderRange(dims.heightMin, dims.heightMax)}
                &nbsp;×&nbsp;
                {renderRange(dims.widthMin, dims.widthMax)}
                &nbsp;×&nbsp;
                {renderRange(dims.lengthMin, dims.lengthMax)}
            </div>
        );
    }
}
